import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');

// This check enables proper hydration when react-snap pre-renders your pages
if (rootElement.hasChildNodes()) {
  // Pre-rendered HTML exists → Hydrate it (best for SEO & performance)
  hydrateRoot(
    rootElement,
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
} else {
  // Normal client-side rendering (when running locally with npm start)
  const root = createRoot(rootElement);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}